/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async startNewPeriod(opening_date, closing_date) {
    let data = {
      opening_date: opening_date,
      closing_date: closing_date,
    };
    let response = await apiCall("period/start", data);
    return response;
  },

  async getCurrentPeriod() {
    let data = { client: "web" };
    let response = await apiCall("period/current", data);
    return response;
  },

  async switchPeriod(period_id) {
    let data = { period_id: period_id };
    let response = await apiCall("period/switch", data);
    return response;
  },

  async listPeriods() {
    let response = await apiCall("period/list", []);
    return response;
  },

   async closePeriod() {
    let response = await apiCall("period/financialperiod/close_current_period", []);
    return response;
  },

  async migrateBalances(data){
    let response = await apiCall('period/financialperiod/migrate_balances', data);
    return response;
  },
  async fetchOpeningBalances(data){
    return await apiCall('transaction/openingbalance/list_opening_balances', data);
  },
  async postOpeningBalance(data){
    return await apiCall('transaction/openingbalance/add_opening_balance', data);
  },
  async fetchOpeningWorth(){
    return await apiCall("transaction/openingbalance/opening_worth", {});
  },
  async deleteOpeningBalance(data){
    return await apiCall('transaction/openingbalance/delete_opening_balance', data);
  },
  async splitOpeningBalance(data){
    return await apiCall('transaction/openingbalance/split', data);
  }
};
